import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=7f5177fe&scoped=true&"
import script from "./Pagination.vue?vue&type=script&lang=ts&"
export * from "./Pagination.vue?vue&type=script&lang=ts&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=7f5177fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5177fe",
  null
  
)

export default component.exports